
import { useState } from 'react';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import MissionSection from './components/MissionSection';
import TopicsGrid from './components/TopicsGrid';
import LatestArticles from './components/LatestArticles';
import Newsletter from './components/Newsletter';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

export default function HomePage() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <CategoryNav 
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
      />
      <FeaturedArticles category={selectedCategory} />
      <MissionSection />
      <TopicsGrid />
      <LatestArticles />
      <Newsletter />
      <Testimonials />
      <Footer />
    </div>
  );
}
